var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.series[0].data.length === 0)?_c('a-alert',{attrs:{"show-icon":false,"message":"No info available","banner":"","type":"info"}}):_c('apexchart',{attrs:{"type":"area","options":_vm.options,"series":_vm.series,"height":250}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }